import { useLocation } from 'react-router-dom';

export function NoMatch() {
    const location = useLocation();
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
            }}
        >
            <h2>404 - Not Found</h2>
            <p>
                Cannot find {location.pathname}. <a href="/">Go Home</a>.
            </p>
        </div>
    );
}
